// @ts-nocheck
(function () {
  const SECTION_SELECTOR = '.main_video_slider_grid_sec_re_ud';

  function ensure_video_source(video) {
    const source = video.querySelector('source[data-src]');
    if (!source || source.src) return;
    source.src = source.getAttribute('data-src');
    video.load();
  }

  function set_play_button_visible(video, visible) {
    const button = video.parentElement
      ? video.parentElement.querySelector('.video_play_icon_re button')
      : null;
    if (!button) return;
    button.style.display = visible ? '' : 'none';
  }

  function play_video(video) {
    const play_promise = video.play();
    if (!play_promise || typeof play_promise.then !== 'function') {
      return Promise.resolve();
    }
    return play_promise.catch(function () {
      return null;
    });
  }

  function pause_all_videos(section) {
    section.querySelectorAll('video').forEach(function (video) {
      video.pause();
      set_play_button_visible(video, true);
    });
  }

  function setup_lazy_loading(section) {
    const videos = section.querySelectorAll('video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(ensure_video_source);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            ensure_video_source(video);
            return;
          }
          try {
            video.pause();
          } catch (e) {}
        });
      },
      { root: null, rootMargin: '500px 0px', threshold: 0.01 }
    );

    videos.forEach(function (video) {
      const rect = video.getBoundingClientRect();
      const near_viewport =
        rect.top < window.innerHeight + 300 && rect.bottom > -300;
      if (near_viewport) ensure_video_source(video);
      observer.observe(video);
    });
  }

  function setup_click_play(section) {
    section.addEventListener('click', function (event) {
      const item = event.target.closest('.inner_video_item_re');
      if (!item || !section.contains(item)) return;

      const video = item.querySelector('video');
      if (!video) return;

      event.stopPropagation();
      ensure_video_source(video);

      const was_playing = !video.paused;
      pause_all_videos(section);
      if (was_playing) return;

      play_video(video).then(function () {
        if (video.paused) return;
        set_play_button_visible(video, false);
      });
    });
  }

  function setup_ended_handlers(section) {
    section.querySelectorAll('video').forEach(function (video) {
      video.addEventListener('ended', function () {
        set_play_button_visible(video, true);
      });
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    setup_lazy_loading(section);
    setup_click_play(section);
    setup_ended_handlers(section);
  }

  init();
})();
